import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { siteConfig } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const Contact = () => {
  const { t } = useLang();
  const { email, phone } = siteConfig.company;

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="scroll-mt-24 bg-[#EAE8E3] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 lg:gap-24">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.contact.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19]">
            {t.contact.title}
          </h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#5C5C59] max-w-md">
            {t.contact.intro}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="bg-[#F4F3EF] border border-stone-300/60 p-8 md:p-12">
            <p className="text-xs font-medium tracking-[0.3em] uppercase text-[#5C5C59]">
              {t.contact.getInTouch}
            </p>

            <div className="mt-8 divide-y divide-stone-300/70">
              <a
                href={`mailto:${email}`}
                data-testid="contact-email"
                className="group flex items-center justify-between gap-4 py-5 text-[#1A1C19] hover:text-[#3A4036] transition-colors"
              >
                <span className="flex items-center gap-4">
                  <Mail size={20} strokeWidth={1.5} />
                  <span className="text-base md:text-lg">{email}</span>
                </span>
                <ArrowUpRight
                  size={18}
                  className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                />
              </a>

              <a
                href={`tel:${phone.replace(/\s+/g, "")}`}
                data-testid="contact-phone"
                className="group flex items-center justify-between gap-4 py-5 text-[#1A1C19] hover:text-[#3A4036] transition-colors"
              >
                <span className="flex items-center gap-4">
                  <Phone size={20} strokeWidth={1.5} />
                  <span className="text-base md:text-lg">{phone}</span>
                </span>
                <ArrowUpRight
                  size={18}
                  className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                />
              </a>

              <div
                data-testid="contact-location"
                className="flex items-center gap-4 py-5 text-[#1A1C19]"
              >
                <MapPin size={20} strokeWidth={1.5} />
                <span className="text-base md:text-lg">{t.common.location}</span>
              </div>
            </div>

            <a
              href={`mailto:${email}`}
              data-testid="contact-email-button"
              className="mt-8 inline-flex items-center gap-2 bg-[#1A1C19] text-[#F4F3EF] px-8 py-4 text-sm font-semibold tracking-wide hover:bg-[#3A4036] transition-colors duration-300"
            >
              {t.contact.emailUs} <ArrowUpRight size={16} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
